
import { LocalStorageKeys } from '../../../common/constant/constantKey';
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import jwt_decode from 'jwt-decode'
import *  as Api from '../../../api/src';
import useCheckToken from './useCheckToken';

const TokenApi = new Api.TokenApi()
const useToken = () => {
    let routerHistory = useHistory();
    const { setCheckToken } = useCheckToken();

    const getToken = () => {
        const tokenString = localStorage.getItem(LocalStorageKeys.Token);
        if (!tokenString) {
            return "";
        }
        const userToken = JSON.parse(tokenString);
        return userToken?.Token
    };
    const getVendor = () => {
        const tokenString = localStorage.getItem(LocalStorageKeys.Token);
        if (!tokenString) {
            return "";
        }
        const userToken = JSON.parse(tokenString);
        return userToken?.CurrentVendor
    }

    useEffect(() => {
        if (window.location.href.toLocaleLowerCase().indexOf("/login") > 0) {
            return;
        }
        const tokenString = getToken();
        if (!tokenString) {
            routerHistory.push("/login");
        }
        if (tokenString) {
            var decodedToken = jwt_decode(tokenString);
            setUserTokenInfo(decodedToken);
        }
    }, []);


    const getUserInfoToken = () => {
        if (!token) return null;
        var decodedToken = jwt_decode(token);
        return decodedToken;
    };
    const saveToken = (userToken: any) => {
        localStorage.setItem(LocalStorageKeys.Token, JSON.stringify(userToken));
        setToken(userToken.token);
    };
    const saveTokenAzure = (tokenAzure: string) => {
        localStorage.setItem(LocalStorageKeys.TokenAzure, JSON.stringify(tokenAzure));
    };
    const clearToken = () => {
        if (!userTokenInfo || !token) return;
        TokenApi.apiIdentityTokenRemoveDeviceTokensDelete(userTokenInfo["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"], localStorage.getItem(LocalStorageKeys.TokenFireBase) || "");
        localStorage.removeItem(LocalStorageKeys.Token);
        localStorage.removeItem(LocalStorageKeys.TokenAzure);
        setToken("");
        setUserTokenInfo(null);
        setCheckToken("");
    };


    const [token, setToken] = useState(getToken());
    const [currentVendor, setCurrentVendor] = useState<string>(getVendor());
    const [userTokenInfo, setUserTokenInfo] = useState<any>(getUserInfoToken());
    return {
        setToken: saveToken,
        setTokenAzure: saveTokenAzure,
        clearToken: clearToken,
        userTokenInfo,
        token,
        currentVendor,
    }
}
export default useToken;